var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmilecircleSvgrepocom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4069_11570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5Z",
    stroke: "#1C274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 20C12.313 20.7879 13.6058 21.25 15 21.25C16.3942 21.25 17.687 20.7879 18.75 20",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13.125C20 14.1605 19.4404 15 18.75 15C18.0596 15 17.5 14.1605 17.5 13.125C17.5 12.0895 18.0596 11.25 18.75 11.25C19.4404 11.25 20 12.0895 20 13.125Z",
    fill: "#1C274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15C11.9404 15 12.5 14.1605 12.5 13.125C12.5 12.0895 11.9404 11.25 11.25 11.25C10.5596 11.25 10 12.0895 10 13.125C10 14.1605 10.5596 15 11.25 15Z",
    fill: "#1C274C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4069_11570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilecircleSvgrepocom);
export default __webpack_public_path__ + "static/media/smilecircle_svgrepo.com.5dafa28a81a7d9f522f71118189aaf6c.svg";
export { ForwardRef as ReactComponent };